// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToTop_root__dJ90p","card":"BackToTop_card__HSj_3"};